import React, { useState } from "react";
import { Card, Row, Col, Button, Table, Modal, Spin, Typography } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import UserForm from "./userForm";
import useFetchWithToken from "../../services/api2";

const { Title } = Typography;

const User = () => {
  const [userModalVisible, setUserModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const { data: userData, loading, error, refetchData } = useFetchWithToken("users");

  const handleAddUser = () => {
    setFormData({});
    setUserModalVisible(true);
  };

  const handleEditUser = (record) => {
    setFormData(record);
    setUserModalVisible(true);
  };

  const handleDeleteUser = (userId) => {
    // Implement deletion logic
    console.log("Delete user with ID:", userId);
  };

  const closeModal = () => {
    setUserModalVisible(false);
  };

  const userColumns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "First Name", dataIndex: "firstName", key: "firstName" },
    { title: "Last Name", dataIndex: "lastName", key: "lastName" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Phone", dataIndex: "phoneNumber", key: "phoneNumber" },
    {
      title: "Role",
      dataIndex: ["Role", "name"],
      key: "role",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditUser(record)}
            style={{ marginRight: 8, color: "#0c8c49" }}
          >
            Edit
          </Button>
          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteUser(record.id)}
            style={{ color: "red" }}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Users
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddUser}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add User
            </Button>
          </Col>
        </Row>
        {error && (
          <div style={{ textAlign: "center", color: "red", marginBottom: "20px" }}>
            Error: {error}
          </div>
        )}
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={userColumns}
            dataSource={userData}
            pagination={{ pageSize: 5 }}
            rowKey="id"
            bordered
          />
        )}
      </Card>

      <Modal
        title={formData.id ? "Edit User" : "Add User"}
        visible={userModalVisible}
        onCancel={() => setUserModalVisible(false)}
        footer={null}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <UserForm
          formData={formData}
          setFormData={setFormData}
          closeModal={closeModal}
          refetchData={refetchData}
        />
      </Modal>
    </div>
  );
};

export default User;
